<template>
    <div v-if="eventShow" class="eventViewer-wrap">
        <div class="eventViewer-signal">
        </div>
        <div class="eventViewer-msg">
            {{getEvntMessage.eventType === 'close' ? 'ОРЕДЕР ЗАКРЫТ' : 'ОРДЕР ОТКРЫТ'}}
            {{getEvntMessage.symbol}}
            {{getEvntMessage.eventType === 'close' ? 'РЕЗУЛЬТАТ ' + getEvntMessage.resultDepo : 'ОБЪЁМ ' + getEvntMessage.volume}}
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            eventShow:false,
            msg:null
        }
    },
    computed: {
        ...mapGetters({
            getEvents:'accountevents/events'
        }),
        getEvntMessage() {
           return this.msg;
       } 
    },
    watch: {
      getEvents: function(value) {
            this.eventShow = true;
            this.msg = value[value.length - 1];
      }  
    }
}
</script>

<style lang="less" scoped>
.eventViewer {
    &-wrap {
        height: 100%;
        width: 100%;
        padding-top: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    &-msg {
        writing-mode: vertical-rl;
        text-orientation: mixed;
        font-family: Arimo;
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
        color:#adc7e1;
    }
    &-signal {
        width: 16px;
        height: 16px;
        background: #00ffd0;
        border-radius: 20px;
        margin-bottom: 16px;
    }
}
</style>

